import { SortDropdown } from '@kaiizen/kai-shiki/react';

import { SortMode } from './dashboardTypes';

export type DashboardSortOption = {
  mode: SortMode;
  label: string;
};

type DashboardSortDropdownProps = {
  isOpen: boolean;
  sortMode: SortMode;
  sortOptions: DashboardSortOption[];
  onToggle: () => void;
  onSelect: (mode: SortMode) => void;
};

export const DashboardSortDropdown = ({
  isOpen,
  sortMode,
  sortOptions,
  onToggle,
  onSelect,
}: DashboardSortDropdownProps) => {
  const dropdownOptions = sortOptions.map(option => ({
    value: option.mode,
    label: option.label,
  }));

  const handleSelect = (value: string) => {
    const selectedOption = sortOptions.find(option => option.mode === value);
    if (selectedOption) onSelect(selectedOption.mode);
  };

  return (
    <SortDropdown
      value={sortMode}
      isOpen={isOpen}
      options={dropdownOptions}
      fallbackLabel='Last Updated'
      onToggle={onToggle}
      onSelect={handleSelect}
    />
  );
};
